/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react';
import css from '../../influence/bloggers/blogger/Blogger.module.scss';
import classNames from 'classnames';
import {copyText} from '../../../../functions/copyText';
import {useFullWidth} from '../../../../hooks/useFullWidth';

// Універсальна валідація URL
const validateURL = (value) => {
  if (typeof value !== 'string') return false;
  try {
    new URL(value);
    return true;
  } catch (_) {
    return false;
  }
};

const Settings = ({
  setSettingData,
  settingData,
  settingValidation,
  setSettingValidation,
  setSaveButtonState,
  saveButtonState,
}) => {
  useFullWidth(true);

  const handleChange = (key, value) => {
    setSaveButtonState(1);
    setSettingData((prev) => ({...prev, [key]: value}));
  };

  useEffect(() => {
    const newValidation = {
      source_link: settingData.source_link?.trim() && !validateURL(settingData.source_link.trim()),
    };
    setSettingValidation(newValidation);
  }, [settingData]);

  return (
    <div className='card mb-8'>
      <div className='card-header border-0 p-8 pb-0'>
        <div className='card-title'>
          <span className='text-gray-900'>Настройки</span>
        </div>
      </div>

      <div className='card-body p-8'>
        <div className={css.settings}>
          <div className={css.column}>
            {/* Название блогера */}
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>Название кампании</label>
              <input
                className='form-control form-control-lg form-control-solid'
                value={settingData.name || ''}
                onChange={(e) => handleChange('name', e.target.value)}
              />
            </div>
          </div>

          <div className={css.column}>
            {/* Ссылка на источник */}
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>
                <span className={css.label}>Источник</span>
              </label>
              <div className={classNames(css.inputWrapper)}>
                <input
                  className='form-control form-control-lg form-control-solid'
                  value={settingData.source_link || ''}
                  onChange={(e) => handleChange('source_link', e.target.value)}
                />
                <button
                  className={classNames(css.copy)}
                  onClick={() => copyText(settingData.source_link || '')}
                  type='button'
                >
                  <i className='ki-duotone ki-copy text-gray-500 p-0 fs-2'></i>
                </button>
              </div>
              {!!settingValidation?.source_link && (
                <div className='fs-6 fw-semibold form-label mb-2 text-danger'>
                  Неправильная ссылка
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
